import { IRecipe } from '@/_types'
import { Box, Container, Grid, Text } from '@chakra-ui/react'
import RecipeCard from '../../Card'
import BreadcrumbComponent from '@/_components/Breadcrumbs'
import { useTranslations } from 'next-intl'
import Header from '@/app/[locale]/(home)/_components/Header'
import { SegmentedControl } from '@/components/ui/segmented-control'
import { BRAND_NAMES, FEATURED_BRANDS } from '@/_utils/Constants'
import RecipeEmptyState from '../empty-state'

export default function Desktop({
  data,
  activeBrandId,
  setActiveBrandId,
  isLoading,
}: {
  data?: IRecipe[]
  activeBrandId: string
  setActiveBrandId: (id: string) => void
  isLoading: boolean;
}) {
  const t = useTranslations()

  const BREADCRUMB_DATA = [
    {
      title: t('home'),
      link: '/',
    },
    {
      title: t('recipes'),
      link: '/recipes',
    },
  ]

  return (
    <Box bg={'background'} minH={'100dvh'} pb={10}>
      <Header />
      <Container mb={8}>
        <BreadcrumbComponent data={BREADCRUMB_DATA} />

        <Text as='h1' fontWeight={700} fontSize='24px' mb={4} letterSpacing='-3%'>
          {t('recipes')}
        </Text>
        <Box mb={6}>
          <SegmentedControl
            size='lg'
            variant='primary'
            height='48px'
            fontWeight={600}
            value={activeBrandId}
            onValueChange={(e) => {
              if (e.value) setActiveBrandId(e.value)
            }}
            items={Object.entries(BRAND_NAMES)
              // Hide Yoko Pizza
              .filter(([id]) => id !== FEATURED_BRANDS.yokopizza)
              ?.map(([id, name]) => ({
              label: name,
              value: id,
            }))}
          />
        </Box>
        {isLoading ? null : data?.length ? (
          <Grid templateColumns='repeat(3, 1fr)' gap={4}>
            {data.map((el) => (
              <RecipeCard key={el.id} data={el} shipperId={activeBrandId} />
            ))}
          </Grid>
        ) : (
          <RecipeEmptyState />
        )}
      </Container>
    </Box>
  )
}
